/**
 * VCloud template configuration
 * Matches: Cloud.VCloud, V2G
 *
 * Special features:
 * - Custom grouped expanded row (Service -> Type -> Items)
 * - Commitment-based expandable check
 * - Custom information tab with grouped rows
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createVCloudExpandedRowRender } from './expanded-row'
import { defaultQuotaCalculator, commitmentBasedIsExpandable } from '../shared'
import { vcloudInformationConfig } from './information'

// Re-export for direct access
export {
    createVCloudExpandedRowRender,
    transformToVCloudRows,
} from './expanded-row'
export type { VCloudExpandedRow } from './expanded-row'

// Re-export information config
export { vcloudInformationConfig } from './information'
export type { VCloudRow, VCloudColumnVisibility } from './information'

// Re-export register form
export { default as VCloudRegisterForm } from './register-form'

// ============================================================================
// Fields
// ============================================================================

export const VCLOUD_FIELDS: TemplateField[] = [
    { key: 'cpu', names: ['cpu', 'vcore', 'vcpu'], label: 'CPU' },
    { key: 'memory', names: ['memory', 'ram'], label: 'Memory' },
    { key: 'disk', names: ['disk', 'ssd', 'hdd', 'storage'], label: 'Disk' },
    { key: 'ip', names: ['ip', 'ip-address', 'ipv4', 'ipv6'], label: 'IP' },
    { key: 'bandwidth', names: ['bandwidth', 'bw'], label: 'Bandwidth' },
]

// ============================================================================
// Template Config
// ============================================================================

export const vcloudTemplate: TemplateConfig = {
    id: 'vcloud',
    patterns: ['vcloud', 'v2g'],
    priority: 10,

    fields: VCLOUD_FIELDS,

    expandedRow: {
        createRenderer: createVCloudExpandedRowRender,
        isExpandable: commitmentBasedIsExpandable,
    },

    information: vcloudInformationConfig,

    calculateQuota: defaultQuotaCalculator,

    registerForm: {
        type: 'vcloud',
    },
}
